// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__203nL","pagination__label":"styles_pagination__label__2CtTn","pagination__button":"styles_pagination__button__2aYho"};